import { Checkbox } from 'antd';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import { CardBrands } from 'types';
import { IFormMccCard } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import BaseMccField from './components/BaseMccField';
import CardBrand from './components/MccCard/CardBrand';
import React, { useEffect, useState } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './Mcc.module.scss';

interface IMcc {
	changeBaseMcc: (value: Nullable<number>) => void;
	mccCards: IFormMccCard[];
	selectedMainMccCardBrand: CardBrands | null;
	useCustomerMcc: boolean;
	reservedMccCardBrands: (CardBrands | null)[];
	toggleUseCustomerMcc: () => void;
	changeMainMccCardBrand: (value: CardBrands) => void;
	changeMainMccCardMcc: (value: Nullable<number>) => void;
	changeMccCardBrand: (id: string, value: CardBrands) => void;
	changeMccCardMcc: (id: string, value: Nullable<number>) => void;
	addMccCard: (value: IFormMccCard) => void;
	deleteMccCard: (id: string) => void;
}

const Mcc: React.FC<IMcc> = ({
	mccCards,
	changeMccCardMcc,
	changeMainMccCardBrand,
	changeMainMccCardMcc,
	addMccCard,
	deleteMccCard,
	changeMccCardBrand,
	reservedMccCardBrands,
	selectedMainMccCardBrand,
	changeBaseMcc,
	useCustomerMcc,
	toggleUseCustomerMcc,
}) => {
	const [isShowAdditionalMccCards, setShowAdditionalMccCards] = useState<boolean>(false);
	const expandIconClasses = classNames(style.expandIcon, { [style.rotated]: isShowAdditionalMccCards });

	useEffect(() => {
		mccCards.length < 1 && setShowAdditionalMccCards(false);
	}, [mccCards.length]);

	const toggleShowAdditionalMccCards = () => {
		setShowAdditionalMccCards((prevState) => !prevState);
	};

	return (
		<div className={style.container}>
			<Button
				className={style.expandButton}
				theme="secondaryPurple"
				onClick={toggleShowAdditionalMccCards}
				disabled={mccCards.length < 1}
				data-test="expandButton"
				icon={
					<svg className={expandIconClasses}>
						<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
					</svg>
				}>
				<Text
					translationNameSpace="form"
					translationKey={isShowAdditionalMccCards ? 'hideAddedFieldsButton' : 'expandAddedFieldsButton'}
					asFragment={true}
				/>
			</Button>
			<Checkbox
				className={style.checkBox}
				checked={useCustomerMcc}
				onChange={toggleUseCustomerMcc}
				data-test="useCustomerSettings">
				<Text translationNameSpace="form" translationKey="useCustomerSettingsLabel" asFragment={true} />
			</Checkbox>
			<BaseMccField changeBaseMcc={changeBaseMcc} useCustomerMcc={useCustomerMcc} />
			<CardBrand
				selectedMainMccCardBrand={selectedMainMccCardBrand}
				reservedMccCardBrands={reservedMccCardBrands}
				changeMainMccCardMcc={changeMainMccCardMcc}
				changeMainMccCardBrand={changeMainMccCardBrand}
				addMccCard={addMccCard}
				setShowAdditionalMccCards={setShowAdditionalMccCards}
				mccCards={mccCards}
				deleteMccCard={deleteMccCard}
				changeMccCardBrand={changeMccCardBrand}
				changeMccCardMcc={changeMccCardMcc}
				isShowAdditionalMccCards={isShowAdditionalMccCards}
				useCustomerMcc={useCustomerMcc}
			/>
		</div>
	);
};

export default React.memo(Mcc);
